@if (isMobile()) {
  <div>
    <div class="flex flex-col items-center">
      <p-avatar
        class="mr-2"
        class="bg-primary-500 dark:bg-primary-700 text-white dark:outline-primary-600 outline-primary-200 outline outline-offset-4 cursor-pointer"
        [label]="initials()"
        (click)="op.toggle($event)"
        shape="circle"
      />
    </div>
  </div>
} @else {
  <div class="relative flex w-full cursor-pointer items-center space-x-1 pb-4 pl-4 pt-2 lg:px-4">
    <div
      class="flex flex-col items-center"
      (click)="op.toggle($event)"
      (keyup.enter)="op.toggle($event)"
      tabindex="2"
    >
      <p-avatar
        class="mx-2 bg-primary-500 dark:bg-primary-700 text-white dark:outline-primary-700 outline-primary-200 outline outline-offset-4 cursor-pointer text-sm font-medium"
        [label]="initials()"
        shape="circle"
        size="large"
      />
    </div>
    <div
      class="max-w-36 flex-1 pl-1 text-surface-500 dark:text-surface-400"
      (click)="op.toggle($event)"
      (keyup.enter)="op.toggle($event)"
      tabindex="2"
    >
      <h4 class="text-md truncate font-medium text-surface-700 dark:text-surface-300">
        @if (activeUser()) {
          {{ name() }}
        } @else {
          <p-skeleton></p-skeleton>
        }
      </h4>

      <p class="max-w-full text-sm">
        @if (customerName()) {
          {{ customerName() }}
        } @else {
          <p-skeleton styleClass="mt-1"></p-skeleton>
        }
      </p>
    </div>
    <i class="pi pi-angle-down text-surface-500"></i>

    <ng-content></ng-content>
  </div>
}

<p-popover
  (onHide)="showAccountMenu.set(false)"
  (onShow)="showAccountMenu.set(true)"
  #op
>
  <div class="h-96 max-h-full overflow-y-auto">
    @if (showAccountMenu()) {
      <bk-account-menu></bk-account-menu>
    }
  </div>
</p-popover>
